import {
	alignment,
	annotation,
	backgroundColor,
	blockCard,
	block_content,
	blockRootOnly,
	blockquote,
	blockTaskItem,
	bodiedExtension,
	bodiedExtension_with_marks,
	border,
	breakout,
	bulletList,
	caption,
	code,
	codeBlock,
	codeBlock_root_only,
	text_with_no_marks,
	confluenceInlineComment,
	dataConsumer,
	date,
	decisionItem,
	decisionList,
	doc,
	em,
	embedCard,
	emoji,
	expand,
	expand_root_only,
	extension,
	extensionFrame,
	extension_with_marks,
	fragment,
	hardBreak,
	heading,
	heading_with_alignment,
	heading_with_indentation,
	heading_with_no_marks,
	indentation,
	inlineCard,
	inlineExtension,
	inlineExtension_with_marks,
	inline_content,
	layoutColumn,
	layoutSection,
	layoutSection_full,
	layoutSection_with_single_column,
	link,
	listItem,
	media,
	mediaGroup,
	mediaInline,
	mediaSingle,
	mediaSingle_caption,
	mediaSingle_full,
	mention,
	multiBodiedExtension,
	nestedExpand,
	nestedExpand_with_no_marks,
	non_nestable_block_content,
	orderedList,
	panel,
	paragraph,
	paragraph_with_alignment,
	paragraph_with_indentation,
	paragraph_with_no_marks,
	placeholder,
	rule,
	status,
	strike,
	strong,
	subsup,
	table,
	tableCell,
	tableHeader,
	tableRow,
	taskItem,
	taskList,
	text,
	textColor,
	text_code_inline,
	text_formatted,
	text_link_inline,
	underline,
} from '@atlaskit/adf-schema/schema-validator';

import type { ValidatorSpec } from './types';

const blockCardTyped = blockCard as unknown as ValidatorSpec;
const inlineCardTyped = inlineCard as unknown as ValidatorSpec;
const mediaTyped = media as unknown as ValidatorSpec;
export const allSpecs: Record<string, ValidatorSpec> = {
	alignment,
	annotation,
	backgroundColor,
	blockCard: blockCardTyped,
	block_content,
	blockRootOnly,
	blockquote,
	blockTaskItem,
	bodiedExtension,
	bodiedExtension_with_marks,
	border,
	breakout,
	bulletList,
	caption,
	code,
	codeBlock,
	codeBlock_root_only,
	text_with_no_marks,
	confluenceInlineComment,
	dataConsumer,
	date,
	decisionItem,
	decisionList,
	doc,
	em,
	embedCard,
	emoji,
	expand,
	expand_root_only,
	extension,
	extensionFrame,
	extension_with_marks,
	fragment,
	hardBreak,
	heading,
	heading_with_alignment,
	heading_with_indentation,
	heading_with_no_marks,
	indentation,
	inlineCard: inlineCardTyped,
	inlineExtension,
	inlineExtension_with_marks,
	inline_content,
	layoutColumn,
	layoutSection,
	layoutSection_full,
	layoutSection_with_single_column,
	link,
	listItem,
	media: mediaTyped,
	mediaGroup,
	mediaInline,
	mediaSingle,
	mediaSingle_caption,
	mediaSingle_full,
	mention,
	multiBodiedExtension,
	nestedExpand,
	nestedExpand_with_no_marks,
	non_nestable_block_content,
	orderedList,
	panel,
	paragraph,
	paragraph_with_alignment,
	paragraph_with_indentation,
	paragraph_with_no_marks,
	placeholder,
	rule,
	status,
	strike,
	strong,
	subsup,
	table,
	tableCell,
	tableHeader,
	tableRow,
	taskItem,
	taskList,
	text,
	textColor,
	text_code_inline,
	text_formatted,
	text_link_inline,
	underline,
} as Record<string, ValidatorSpec>;
